import React from "react";
import { Link } from "react-router-dom";
import { Caravan, ArrowUpRight, Check } from "lucide-react";
import { TOWING_PROMO, lowestPackagePrice, maxSaving, money } from "../../data/promo";

// compact = badge for service pages; default = hero card
export default function PromoCard({ compact = false }) {
  const from = money(lowestPackagePrice());
  const best = money(maxSaving());

  if (compact) {
    return (
      <Link
        to={TOWING_PROMO.path}
        data-testid="promo-badge"
        className="group mt-6 inline-flex flex-col sm:flex-row sm:items-center gap-3 border border-cyan-pz/50 bg-cyan-pz/5 px-5 py-4 hover:bg-cyan-pz/10 transition-colors"
      >
        <span className="inline-flex items-center gap-2 bebas text-cyan-pz tracking-[0.25em] text-xs">
          <Caravan className="w-4 h-4" /> {TOWING_PROMO.eyebrow}
        </span>
        <span className="bebas text-white text-lg tracking-wider leading-tight">
          TOW READY PACKAGES: Tow-Pro + Anderson + 12 pin — prices from {from}, save up to {best}
        </span>
        <span className="inline-flex items-center gap-1 bebas text-cyan-pz tracking-widest text-sm group-hover:gap-2 transition-all">
          DETAILS <ArrowUpRight className="w-4 h-4" />
        </span>
      </Link>
    );
  }

  return (
    <div
      data-testid="promo-card"
      className="mt-10 max-w-2xl border border-cyan-pz/50 bg-black/70 backdrop-blur-md p-6 md:p-7 relative overflow-hidden"
    >
      <div className="absolute -right-6 -top-6 w-28 h-28 bg-cyan-pz/10 rotate-12" aria-hidden="true" />
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <span className="inline-flex items-center gap-2 bg-cyan-pz text-black px-3 py-1 bebas tracking-[0.25em] text-xs clip-tag">
          <Caravan className="w-3.5 h-3.5" /> {TOWING_PROMO.eyebrow}
        </span>
        <span className="bebas text-white/60 tracking-[0.25em] text-xs">ONE WORKSHOP DAY</span>
      </div>
      <h2 className="bebas text-white text-3xl md:text-4xl leading-[0.95]">
        TOW READY PACKAGES — <span className="text-cyan-pz">FROM {from}</span> <span className="text-white/60 text-2xl md:text-3xl">· SAVE UP TO {best}</span>
      </h2>
      <ul className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
        {[
          `Tow-Pro + Anderson — from ${money(TOWING_PROMO.packages[0].price.basic)}`,
          `Tow-Pro + Anderson + 12 pin* — from ${money(TOWING_PROMO.packages[2].price.basic)}`,
          `With ignition relay or reverse-sensor switch — see all 5 packages`,
        ].map((t) => (
          <li key={t} className="flex items-start gap-2 text-white/85 barlow text-sm leading-snug">
            <Check className="w-4 h-4 text-cyan-pz shrink-0 mt-0.5" />
            <span>{t}</span>
          </li>
        ))}
      </ul>
      <div className="mt-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <Link
          to={TOWING_PROMO.path}
          data-testid="promo-card-link"
          className="inline-flex items-center justify-center gap-2 bg-cyan-pz text-black px-6 py-3 bebas text-lg tracking-[0.2em] hover:bg-white transition-colors clip-perf self-start"
        >
          SEE THE PACKAGES <ArrowUpRight className="w-4 h-4" />
        </Link>
        <p className="text-white/50 barlow text-xs leading-snug">
          Savings vs our individual prices. Prices from, GST inc. *Standard 12 pin only — wiring diagram required.
        </p>
      </div>
    </div>
  );
}
